import React, { useState } from "react";
import "../styles/intake.css";

const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Holiday"];

// Generate time options in 30-minute intervals
const hours = [];
for (let h = 0; h < 24; h++) {
  for (let m = 0; m < 60; m += 30) {
    const hour = h % 12 === 0 ? 12 : h % 12;
    const minute = m === 0 ? "00" : m;
    const ampm = h < 12 ? "AM" : "PM";
    hours.push(`${hour}:${minute} ${ampm}`);
  }
}


function convertTo24Hour(timeStr) {
  if (!timeStr) return "";
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
}


export default function BusinessHoursForm({ formData, setFormData }) {
  const [isEditing, setIsEditing] = useState(true);

  const handleChange = (day, type, value) => {
    setFormData((prev) => ({
      ...prev,
      business_hours: {
        ...prev.business_hours,
        [day]: {
          ...(prev.business_hours?.[day] || {}),
          [type]: value,
        },
      },
    }));
  };

  const handleClosedToggle = (day) => {
    const isClosed = formData.business_hours?.[day]?.closed;
    setFormData((prev) => ({
      ...prev,
      business_hours: {
        ...prev.business_hours,
        [day]: {
          closed: !isClosed,
          open: !isClosed ? "" : "9:00 AM",
          close: !isClosed ? "" : "5:00 PM",
        },
      },
    }));
  };

  const handleSave = async () => {
    // Convert time strings to 24-hour format before sending
    const convertedHours = {};
    for (const day in formData.business_hours) {
    const dayData = formData.business_hours[day] || {};
    convertedHours[day] = {
    closed: typeof dayData.closed === "boolean" ? dayData.closed : false,
    open: convertTo24Hour(dayData.open),
    close: convertTo24Hour(dayData.close),
   };
  }

  
    const payload = {
      clinic_id: formData.clinic_id,
      business_hours: convertedHours,
      walk_in_allowed: formData.walk_in_allowed,
    };
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/save-clinic-profile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      const result = await response.json();
      if (response.ok) {
        alert("✅ Business hours saved successfully!");
        setIsEditing(false);
      } else {
        if (Array.isArray(result.detail)) {
          alert("❌ Save failed:\n" + result.detail.map(d => `${d.loc?.join(".")}: ${d.msg}`).join("\n"));
        } else {
          alert("❌ Save failed: " + result.detail);
        }
      }
    } catch (error) {
      alert("❌ Save error: " + error.message);
    }
  };
  

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleWalkInChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      walk_in_allowed: value,
    }));
  };

  return (
    <div className="form-wrapper">
      {/* Header */}
      <div className="form-section-header">
        <h2>2. <span className="section-title">Business Hours</span></h2>
        <div className="form-buttons">
          {isEditing ? (
            <button className="blue-button" onClick={handleSave}>Save</button>
          ) : (
            <button className="blue-button" onClick={handleEdit}>Edit</button>
          )}
        </div>
      </div>

      <div className="separator" />

      {/* Table */}
      <div className="business-hours-box">
        <div className="business-hours-table">
          <div className="table-header">
            <strong>Day</strong>
            <strong>Open</strong>
            <strong>Close</strong>
            <strong>Closed</strong>
          </div>
          {daysOfWeek.map((day) => {
            const isClosed = formData.business_hours?.[day]?.closed ?? (day === "Saturday" || day === "Holiday");

            return (
              <div className="table-row" key={day}>
                <span>{day}</span>
                <select
                  disabled={isClosed}
                  value={formData.business_hours?.[day]?.open || ""}
                  onChange={(e) => handleChange(day, "open", e.target.value)}
                  className="hour-select"
                >
                  <option value="">--</option>
                  {hours.map((time) => (
                    <option key={time} value={time}>{time}</option>
                  ))}
                </select>
                <select
                  disabled={isClosed}
                  value={formData.business_hours?.[day]?.close || ""}
                  onChange={(e) => handleChange(day, "close", e.target.value)}
                  className="hour-select"
                >
                  <option value="">--</option>
                  {hours.map((time) => (
                    <option key={time} value={time}>{time}</option>
                  ))}
                </select>
                <input
                  type="checkbox"
                  checked={isClosed}
                  onChange={() => handleClosedToggle(day)}
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* Walk-in Allowed */}
      <div className="walk-in-wrapper">
        <div className="form-field radio-group-inline">
          <label>Walk-In Allowed?</label>
          <div className="radio-options">
            <label>
              <input
                type="radio"
                name="walkin"
                value="yes"
                checked={formData.walk_in_allowed === true}
                onChange={() => handleWalkInChange(true)}
              /> Yes
            </label>
            <label>
              <input
                type="radio"
                name="walkin"
                value="no"
                checked={formData.walk_in_allowed === false}
                onChange={() => handleWalkInChange(false)}
              /> No
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}